<template>
    <div class="main">
        <span @click="search()">
            <Button type="primary" @click="modal = true" v-hasPermission="['monitor:messageQueueMonitor:add_alert_rule']">{{ $t('alarms.queue.addQueue') }}</Button>
        </span>
        <Modal v-model="modal" :title="$t('alarms.queue.addQueue')" @on-ok="handleSubmit('messageQueueForm')" width="900px;" :loading="modalLoading" :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')" :mask-closable="false" @on-cancel="cancel('messageQueueForm')">
            <Form :model="messageQueueForm" :label-width="100" ref="messageQueueForm" :rules="ruleValidate">
                <!-- 搜索 -->
                <Row :gutter="16">
                    <Col span="8">
                        <!-- 账户 -->
                        <FormItem :label="$t('alarms.common.account')" prop="account">
                            <Select v-model="messageQueueForm.account" filterable @on-change="changeAccount(messageQueueForm.account)" :transfer="true" placeholder="">
                                <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="8" style="z-index: 200">
                        <!-- 存储区域 -->
                        <FormItem :label="$t('alarms.common.region')" prop="region">
                            <Select filterable @on-change="changeRegion(messageQueueForm.region)"
                                v-model="messageQueueForm.region" :transfer="true" placeholder="">
                                <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <!-- 标签 -->
                        <FormItem :label="$t('alarms.common.tags')" prop="tags" :label-width="40">
                            <Input v-model="messageQueueForm.tags" placeholder=""/>
                        </FormItem>
                    </Col>
                    <Button type="primary" style="float:right;" v-show="isShowSearch" @click="searchMessageQueueInput()"> {{ $t('alarms.common.search') }} </Button>
                </Row>
            </Form>
            <Table :no-data-text="$t('common.noData')" ref="selection" :columns="columns4" :loading="loading" :data="messageQueueData" :height="400" @on-selection-change="getSelection"></Table>
        </Modal>
    </div>
</template>

<script>
    import {getCookie} from '../../../utils/cookieUtil.js'
    import TableMessageQueue from '../mq/TableMessageQueue'

    var tableMessageQueue = TableMessageQueue;
    export default {
        name: 'AddMessageQueue',
        components: {
            TableMessageQueue
        },
        data() {
            return {
                selection: [],
                modal: false,
                modalLoading: true,
                loading: false,
                accountList: [],
                regionList: [],
                isShowSearch: false,
                messageQueueForm: {
                    account: '',
                    region: '',
                    tags: ''
                },
                ruleValidate: {
                    account: [
                        {required: true, message: this.$t('monitor.alarmRule.accountRequired'), trigger: 'change', type: 'number'}
                    ],
                    region: [
                        {required: true, message: this.$t('monitor.alarmRule.regionRequired'), trigger: 'change'}
                    ]
                },
                columns4: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: this.$t('alarms.queue.name'),
                        key: 'brokerName',
                        width: '120px'
                    },
                    {
                        title: this.$t('alarms.queue.brokerId'),
                        key: 'brokerId'
                    },
                    {
                        title: this.$t('alarms.queue.instanceType'),
                        key: 'hostInstanceType'
                    },
                    {
                        title: this.$t('alarms.common.status'),
                        key: 'stateName'
                    },
                    {
                        title: this.$t('alarms.queue.region'),
                        key: 'region'
                    }
                ],
                messageQueueData: [],
                newMessageQueueDataList:[]
            }
        },
        methods: {
            search:function(){
                this.selectAccount();
            },
            // 查询账户
            selectAccount: function () {
                this.$api.account.queryAWSCloudAccounts("userName", getCookie(global.cookieName))
                    .then(res => {
                        this.accountList = res.data;
                        for (var i = 0; i < this.accountList.length; i++) {
                            this.accountList[i].name = this.accountList[i].name + '(' + this.accountList[i].accountTypeName + ')';
                        }
                    })
            },
            // 切换账户
            changeAccount: function () {
                if (this.messageQueueForm.account == "" || this.messageQueueForm.account == null) {
                    return;
                }
                this.messageQueueForm.region = '';
                this.isShowSearch = true;
                this.$api.account.queryAccountRegions("accountId", this.messageQueueForm.account)
                    .then(res => {
                        this.regionList = res.data;
                    })
            },
            // 切换存储区域
            changeRegion: function () {
                this.instanceList = [];
                this.isShowSearch = true;
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newMessageQueueDataList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var TableMessageQueueDataCopy = new Object();
                    TableMessageQueueDataCopy.brokerName = this.selection[i].brokerName;
                    TableMessageQueueDataCopy.brokerId = this.selection[i].brokerId;
                    TableMessageQueueDataCopy.hostInstanceType = this.selection[i].hostInstanceType;
                    TableMessageQueueDataCopy.region = this.selection[i].region;
                    TableMessageQueueDataCopy.stateName = this.selection[i].stateName;
                    TableMessageQueueDataCopy.state = this.selection[i].state;
                    TableMessageQueueDataCopy.accountId = this.selection[i].accountId;
                    this.newMessageQueueDataList.push(TableMessageQueueDataCopy);
                }
            },
            // 点击查询
            searchMessageQueueInput: function () {
                if (this.messageQueueForm.account == "" || this.messageQueueForm.account == null || this.messageQueueForm.region == "" || this.messageQueueForm.region == null) {
                    return;
                }
                this.loading=true;
                // 根据AccountId查询队列列表
                this.$api.brokerSummary.queryBrokerByAccountId({
                    "region": this.messageQueueForm.region,
                    "accountId": this.messageQueueForm.account,
                    "monitorModule":16
                }).then(res => {
                    this.messageQueueData = res.data.brokerSummaryDTOList;
                    this.loading=false;
                })
            },
            // 添加
            handleSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 增加
                        this.$api.brokerSummary.createBrokerSummary({
                            "region": this.messageQueueForm.region,
                            "accountId": this.messageQueueForm.account,
                            "brokerSummaryDTOList":this.newMessageQueueDataList
                        })
                        .then(res => {
                            setTimeout(() => {
                                tableMessageQueue.methods.showAll();
                                this.$refs[name].resetFields();
                                this.modalLoading = false;
                                this.$nextTick(() => {
                                    this.modalLoading = true;
                                });
                                this.$Message.success(this.$t('common.addSuccess'));
                                this.messageQueueData=[];
                                this.newMessageQueueDataList=[];
                                this.modal = false;
                            }, 1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.modalLoading = false;
                        setTimeout(() => {
                            this.modalLoading = true
                        }, 0)
                        this.$Message.error(this.$t('common.addFail'));
                    }
                });
            },
             // 取消
            cancel: function (name) {
                this.modal = false;
                this.loading = false;
                this.messageQueueData=[];
                this.newMessageQueueDataList=[];
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>
    .main>>>.ivu-modal-wrap{
        z-index:1000 !important;
    }
    .main>>>.ivu-modal-mask{
        z-index:1000 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/mq/AddMessageQueue.vue